import { CustomerAddress } from './customer-address';
import { Customer } from './customer';

export class MarketPrice {
    id:number = 0;
    customer_id:number = 0;
    customer:Customer = new Customer();
    customer_address_id:number = 0;
    customer_address:CustomerAddress = new CustomerAddress();
    price:number = 0;   
    price_by_travel:number = 0;
    limit_ton:number = 0;
}